"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _capture = _interopRequireDefault(require("../utils/capture"));
var _asyncLoadingSentry = _interopRequireDefault(require("../utils/asyncLoadingSentry"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @function
 * @name SentryCapture - 页面主动上报异常
 * @desc 主动上报前端异常错误
 * @param {string} err 错误信息
 * @param {string} [type=info] 错误类型: error 高危（严重）、warning 警告、info 提示
 * @param {object} [opts={}] 合并发布对象，例如 {tags: ..., extra: ...}
 * @param
 * @example
 * import { SentryCapture } from '@zz-common/sentry';
 * 
 * // 安装错误异常上报系统
 * SentryCapture('有错误', 'error', {
 *  tags: {
 *    test: 'test'
 *  }
 * });
 * 
 * // vue组件级别错误捕获
 * Vue.component('ErrorBoundary', {
 *   data: () => ({ error: null }),
 *   errorCaptured(err, vm, info) {
 *     this.error = `${err.stack}\n\nfound in ${info} of component`;
 *     SentryCapture(this.error, 'error');
 *     return false;
 *   },
 *   render(h) {
 *     if (this.error) {
 *       return null;
 *     }
 *     return (this.$slots.default || [null])[0] || null;
 *   },
 * });
 */
// 抓取所有promise没有执行catch的错误
var isServer = void 0 === 'window' ? false : true; // 判断是否是ssr

var newCapture = function newCapture(err) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var WSentry = arguments.length > 3 ? arguments[3] : undefined;
  var other = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var currSentry = WSentry || (typeof window === 'undefined' ? null : window.Sentry);
  if (currSentry) {
    (0, _capture.default)(err, type, opts, currSentry, other);
  } else {
    (0, _asyncLoadingSentry.default)(function (CSentry) {
      (0, _capture.default)(err, type, opts, CSentry, other);
    });
  }
};
if (!isServer) {
  window.addEventListener('unhandledrejection', function (event) {
    newCapture(event.reason, 'info', {
      extra: _objectSpread({
        errorInfo: 'ssr-抓取所有promise没有执行catch的错误'
      }, event || {})
    });
  });
}
var _default = exports.default = newCapture;